import React, { useMemo } from "react";
import {
    Paper,
    Typography,
    Stack,
    Box,
    Button,
    Chip,
} from "@mui/material";

import { useNavigate } from "react-router-dom";

import { mockConversations } from "../../../mocks/mockConversations";
import { buildPriorityQueue } from "../../utils/priorityQueue";

function PriorityBadge({ priority }) {
    if (priority === "alta") {
        return <Chip label="Alta" size="small" color="error" />;
    }

    if (priority === "media") {
        return <Chip label="Média" size="small" color="warning" />;
    }

    return <Chip label="Baixa" size="small" />;
}

export default function PriorityQueue() {
    const navigate = useNavigate();

    const leads = useMemo(
        () => buildPriorityQueue(mockConversations),
        []
    );

    return (
        <Paper
            elevation={0}
            sx={{
                p: 2.5,
                borderRadius: 3,
                border: "1px solid var(--border)",
                background: "var(--branco)",
                width: "100%",
            }}
        >
            <Typography
                sx={{
                    fontWeight: 800,
                    color: "var(--cise-blue)",
                    mb: 2,
                }}
            >
                Responder agora
            </Typography>

            <Stack spacing={2}>
                {leads.length === 0 && (
                    <Typography
                        sx={{
                            fontSize: 13,
                            color: "var(--cise-text-muted)",
                        }}
                    >
                        Nenhum lead aguardando resposta 🎉
                    </Typography>
                )}

                {leads.map((lead) => (
                    <Box
                        key={lead.id}
                        sx={{
                            p: 1.6,
                            borderRadius: 2,
                            border: "1px solid var(--border)",
                            background: "var(--branco)",
                            transition: "0.15s",
                            "&:hover": {
                                borderColor: "rgba(33,49,89,0.28)",
                                transform: "translateY(-1px)",
                            },
                        }}
                    >
                        <Stack spacing={0.5}>
                            <Stack
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <Typography fontWeight={700}>
                                    {lead.name}
                                </Typography>

                                <PriorityBadge priority={lead.priority} />
                            </Stack>

                            <Typography
                                sx={{
                                    fontSize: 13,
                                    color: "var(--cise-text-muted)",
                                }}
                            >
                                {lead.interest}
                            </Typography>

                            <Typography
                                sx={{
                                    fontSize: 13,
                                    mt: 0.5,
                                }}
                            >
                                “{lead.lastMessage}”
                            </Typography>

                            <Stack
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                sx={{ mt: 1 }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: 12,
                                        color: "var(--cise-text-muted)",
                                    }}
                                >
                                    aguardando há {lead.waitingLabel}
                                </Typography>

                                <Button
                                    size="small"
                                    variant="contained"
                                    onClick={() =>
                                        navigate(`/admin/conversas?open=${lead.id}`)
                                    }
                                    sx={{
                                        textTransform: "none",
                                        fontWeight: 700,
                                        background: "var(--cise-blue)",
                                        "&:hover": {
                                            background: "var(--cise-blue)",
                                        },
                                    }}
                                >
                                    Abrir conversa
                                </Button>
                            </Stack>
                        </Stack>
                    </Box>
                ))}
            </Stack>
        </Paper>
    );
}
